module.exports = __webpack_public_path__ + "static/covid-19-5-9bbea4df84db3ffcafba648087f94781.jpg";